/**
 * RuleFlowIcon — An entry point and the chain of steps it starts: a rule flow. Hugeicons
 * flowchart-02 (MIT).
 */

import svg from './svg/rule-flow.svg?raw';
import { makeSvgIcon } from './svgIcon';

export const RuleFlowIcon = makeSvgIcon('rule-flow', svg);
